<template>
    <div id="Home">
        <nav>
            <img src="../assets/img/logo.png" alt="">
            <span>|</span>
            <span>济南城管“便民公厕”地图</span>
        </nav>
        <div class="content">
            <div class="left-nav" :style="{width:(leftOpen?'320px':'0')}">
                <div class="search-content">
                    <div class="search-box">
                        <input type="text" placeholder="请输入公厕名称" v-model="keywords">
                        <div>
                            <div class="icon-bg" @click="getSearchSchool">
                                <img src="../assets/img/sousuo.png" alt="">
                            </div>
                        </div>
                    </div>
                    <el-select @change="areaSelectChanged" style="display: block;width: 260px;margin: 0 auto" v-model="areaSelect" placeholder="请选择区县">
                        <el-option
                            v-for="(item,idx) in selectList"
                            :key="idx"
                            :label="item.title"
                            :value="item.title">
                        </el-option>
                    </el-select>
                    <!--                    <div class="select-box">-->
                    <!--                        <div>筛选</div>-->
                    <!--                        <div>-->
                    <!--                            <div-->
                    <!--                                v-for="(item, index) of selectBtn"-->
                    <!--                                :key="index" :class="{select: item.select}"-->
                    <!--                                @click="changeSelect(item)"-->
                    <!--                            >{{item.name}}-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
                <div class="nav-list">
                    <div class="school-box">
                        <div :class="{'school-item': true, 'school-item-focus': schoolItemIndex === index}"
                             v-for="(school, index) of highSchoolList"
                             :key="index"
                             @click="toSchoolInfo(school, index)"
                             v-show="navContent">
                            <div>{{school.title}}</div>
                            <span>〉</span>
                        </div>
                    </div>
                </div>
                <div class="openBtnView leftViewBtn" :class="{'closeLeft':!leftOpen}" @click="hideNavlist">
                        <span class="openBtn "
                              :style="{backgroundImage:'url('+(leftOpen?openRight:openLeft)+')'}">
                        </span>
                </div>
            </div>
            <div class="map-content">
                <div id="map" v-show="content === '地图'"></div>
                <div class="school-info" v-show="content === '地图' && schoolInfo">
                    <img src="../../src/assets/img/close.png" alt=""
                         style="position: absolute;top: 10px;right: 10px;cursor: pointer" @click="close">
                    <Table
                        style="background-color: #f2a807"
                        :data="mockeTableData"
                        max-height="605px"
                    >
                        <!--                        <TableColumn-->
                        <!--                            v-for="(item,idx) in tableSys"-->
                        <!--                            :key="idx"-->
                        <!--                            :property="item.value"-->
                        <!--                            :label="item.lable"-->
                        <!--                            :width="getTdWidth(item.value)"-->
                        <!--                        >-->
                        <!--                           <template slot-scope="scope">-->
                        <!--                            <span class="serviceScope"  v-if="item.value==='servicearea'">{{scope.row.servicearea
                        }}</span>-->
                        <!--                            <span v-else>{{scope.row[item.value]}}</span>-->
                        <!--                           </template>-->
                        <!--                        </TableColumn>-->
                        <TableColumn
                            prop="county"
                            label="区县"
                            width='120'
                        >
                        </TableColumn>
<!--                        <TableColumn-->
<!--                            prop="street"-->
<!--                            label="街道"-->
<!--                            width='120'-->
<!--                        >-->
<!--                        </TableColumn>-->
                        <TableColumn
                            prop="title"
                            label="名称"
                            width='300'
                        >
                        </TableColumn>
<!--                        <TableColumn-->
<!--                            prop="name"-->
<!--                            label="路长"-->
<!--                            width='80'-->
<!--                        >-->
<!--                        </TableColumn>-->
<!--                        <TableColumn-->
<!--                            prop="startLocation"-->
<!--                            label="起点"-->
<!--                            width='220'-->
<!--                        >-->
<!--                        </TableColumn>-->
<!--                        <TableColumn-->
<!--                            prop="endLocation"-->
<!--                            label="终点"-->
<!--                            width='220'-->
<!--                        >-->
<!--                        </TableColumn>-->
<!--                        <TableColumn-->
<!--                            prop="tel"-->
<!--                            label="电话"-->
<!--                            width='120'-->
<!--                        >-->
<!--                        </TableColumn>-->
                    </Table>
                </div>
            </div>
        </div>
        <Dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible">
            <div class="details">
                <h1>{{newDetails.title}}</h1>
                <div>{{newDetails.description}}</div>
                <div class="details-content" v-html="newDetails.content"></div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import * as qs from 'query-string'
    import {Dialog, Table, TableColumn} from 'element-ui'

    export default {
        name: "Home",
        components: {
            Dialog,
            Table,
            TableColumn,
        },
        data() {
            return {
                keywords: '',
                areaSelect:'',
                leftOpen: true,
                openLeft: require('../assets/img/openRight.png'),
                openRight: require('../assets/img/openleft.png'),
                activeSchool: null,
                mockeTableData: [],
                tableSys: [],
                dialogVisible: false,
                // nav内容显示内容 true 学校 false 为资讯
                navContent: true,
                // 显示地图还是资讯
                content: '地图',
                stationId: '',
                selectBtn: [
                    {name: '供暖管家', select: true, stype: 1},
                    {name: '营业厅', select: false, stype: 2}
                ],
                highSchoolList: [],
                schoolList: [],
                newParams: {
                    // 资讯604
                    catid: 604,
                    num: 20,
                    page: 1,
                    thumb: 0,
                    school: '',
                },
                areaParams: {
                    type: 2,
                    s_type: 1,
                    area: '',
                },

                schoolInfo: false,
                leftNews: [],
                contentNews: [],
                // 新闻总页数
                newTotal: 0,
                // 一页多少条
                newPageSize: 20,
                schoolDetails: {},
                // 新闻详情
                newDetails: {},
                // 资讯为全部的还是为单独学校的
                infoTitle: '',
                schoolItemIndex: '',
                markerList: [],
                mapObj: null,
                selectList:[]
            }
        },
        methods: {
            areaSelectChanged(val){
                const {selectList}=this
                axios.get(`/index.php?m=content&c=gongce&a=getRoadByCounty&county=${val}`).then(res => {
                    this.highSchoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.schoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.mapObj.destroy();
                    const posi=selectList.filter(item=>item.title===val)
                    this.initMap(posi[0].center.split(','))
                })
            },
            getSelectList() {
                axios.post(`/index.php?m=content&c=gongce&a=getCounty`).then(({data}) => {
                  this.$set(this,'selectList',data[0])
                })
            },
            hideNavlist() {
                this.leftOpen = !this.leftOpen;
                if (this.schoolInfo) {
                    this.schoolInfo = false
                }
            },
            getTdWidth(val) {
                let width = 100
                switch (val) {
                    case 'company':
                        width = 120;
                        break;
                    case 'wenxin':
                        width = 100;
                        break;
                    case 'phone':
                        width = 120;
                        break;
                    case 'servicearea':
                        width = 370;
                        break;
                    case 'title':
                        width = 270;
                        break;
                    case 'description':
                        width = 270;
                        break;
                    case 'sfgx':
                        width = 120;
                        break;
                    default:
                        break
                }
                return width
            },
            changeSelect(item) {
                this.selectBtn.map(btn => btn.select = false)
                item.select = true
                this.navContent = true
                this.schoolInfo = false
                this.areaParams.s_type = item.stype
                this.areaParams.type = 2
                this.getLeftSchool()
            },
            getSearchSchool() {
                this.areaParams.type = 1;
                // this.areaParams.s_type = '';
                this.getLeftSchool()
            },
            close() {
                this.schoolInfo = false;
            },
            /**
             * 初始化地图
             */
            initMap(posi) {
                this.$nextTick(() => {
                    let map = new AMap.Map('map', {
                        center: posi?posi:[117.000923, 36.675807],
                        zoom: 11,
                        // resizeEnable: true
                    })
                    this.mapObj = map;
                    this.markerList = this.schoolList.map((item, index) => {
                        item.center = [parseFloat(item.longitude), parseFloat(item.latitude)]
                        let markerColor = ''
                        markerColor = item.s_type == 1 ? 'rgba(209,72,23,1)' : 'blue';
                        let circleMarker = new AMap.CircleMarker({
                            center: item.center,
                            radius: '10px',//3D视图下，CircleMarker半径不要超过64px
                            strokeColor: 'white',
                            strokeWeight: 2,
                            strokeOpacity: 0.8,
                            fillColor: markerColor,
                            fillOpacity: 0.8,
                            zIndex: 10,
                            bubble: true,
                            cursor: 'pointer',
                            clickable: true,
                            data: {...item, index}
                        })
                        circleMarker.setMap(map)
                        circleMarker.on('click', (e) => this.clickHandler(e, map));
                        circleMarker.on('dblclick', (e) => this.clickHandlerDB(e, map));
                        return circleMarker
                    })
                    this.map = map
                    this.getUserLocation()
                })
            },
            getUserLocation() {
                const {mapObj}=this
                mapObj.plugin('AMap.Geolocation', function () {
                    const geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        GeoLocationFirst:true,
                        timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                        maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                        convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                        showButton: true,        //显示定位按钮，默认：true
                        buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
                        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                        showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                        panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
                        zoomToAccuracy:true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    });
                    mapObj.addControl(geolocation);
                    geolocation.getCurrentPosition();
                    AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
                    AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
                });
                function onComplete(data) {
                    // data是具体的定位信息
                    console.log(data)
                }

                function onError(data) {
                    // 定位出错
                    console.log(data)
                }
            },
            clickHandler(event, map) {
                let data = event.target ? event.target.Ce.data : event
                this.mapObj.setCenter([data.longitude, data.latitude]);
                this.mapObj.setZoom(17);

            },
            clickHandlerDB(event, map) {
                let data = event.target ? event.target.Ce.data : event
                let infoWindow = new AMap.InfoWindow({
                    content: `<div class="info-window">
                                <div>${data.title}</div>
                              </div>`
                })
                infoWindow.open(map, data.center || [data.longitude, data.latitude])
                this.schoolInfo = true;
                this.stationId = data.id;
                this.getmockeTableData(this.stationId)
            },
            toSchoolInfo(school, index) {
                this.schoolItemIndex = index
                this.stationId = school.id;
                this.clickHandler(school, this.map)
                this.map.setZoomAndCenter(this.map.getZoom(), [parseFloat(school.longitude), parseFloat(school.latitude)]); //同时设置地图层级与中心点
                this.schoolInfo = true
                this.getmockeTableData(this.stationId)
            },
            getLeftSchool() {
                axios.post(`/index.php?m=content&c=gongce&a=lists&title=${this.keywords}`).then(res => {
                    this.highSchoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.schoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.mapObj.destroy();
                    const firstRoad=this.schoolList[0]
                    this.initMap([firstRoad.longitude,firstRoad.latitude])
                })
            },
            getAllSchool() {
                axios.post(`/index.php?m=content&c=gongce&a=lists`).then(res => {
                    this.schoolList = res.data
                    this.highSchoolList = res.data
                    this.initMap()
                })
            },
            getmockeTableData(id) {
                const url = '/index.php?m=content&c=gongce&a=roadInfo'
                axios.post(`${url}&id=${id}`).then(res => {
                    this.mockeTableData = [res.data];
                })
            },
            toOutLink(item) {
                if (item.islink !== '0') {
                    window.open(item.url)
                }
            },
        },
        mounted() {
            this.initMap()
            // this.getLeftSchool()
            this.getAllSchool()
            this.getSelectList()
        },
    }
</script>

<style scoped lang="less">
    #Home {
        .serviceScope {
            display: block;
            height: 70px;
            overflow-y: auto;

            &::-webkit-scrollbar-thumb {
                background: #bfbfbf;
                border-radius: 10px;
            }

            &::-webkit-scrollbar {
                width: 7px;
                height: 10px;
            }
        }

        .openBtnView {
            position: absolute;
            z-index: 100;
            background-color: #409EFF;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            width: 10px;
            height: 130px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .openBtn {
            display: block;
            width: 10px;
            height: 10px;
            background-size: 100%;
        }

        .leftViewBtn {
            right: 0;
            border-top-left-radius: 100%;
            border-bottom-left-radius: 100%;
        }

        .closeLeft {
            right: -10px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-top-right-radius: 100%;
            border-bottom-right-radius: 100%;
        }

        nav {
            width: 100%;
            height: 70px;
            display: flex;
            align-items: center;
            background: #f5f5f5;
            border-bottom: 1px solid #DDD;
            box-sizing: border-box;

            > img {
                width: 198px;
                margin: 0 10px 0 23px;
            }

            > span:nth-of-type(1) {
                color: #999;
            }

            > span:nth-of-type(2) {
                margin-left: 10px;
                color: #333333;
                font-size: 20px;
                font-weight: bold;
            }
        }

        .content {
            width: 100%;
            height: calc(100vh - 70px);
            display: flex;
            position: relative;

            .left-nav {
                width: 320px;
                height: 100%;
                background: white;
                padding-top: 20px;
                box-sizing: border-box;
                position: relative;
                /*transition: width .2s linear;*/

                .search-content {
                    height: 95px;

                    .search-box {
                        border: 1px solid #DDD;
                        width: 260px;
                        height: 42px;
                        margin: 0 auto 10px;
                        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                        border-radius: 6px;
                        display: flex;
                        align-items: center;

                        > input {
                            height: 60%;
                            width: 70%;
                            border: none;
                            margin-left: 20px;
                        }

                        > div {
                            width: 20%;
                            height: 80%;
                            border-left: 1px solid #ddd;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .icon-bg {
                                background-color: #F5F5F5;
                                border-radius: 16px;
                                height: 28px;
                                width: 28px;
                                padding: 7px;
                                box-sizing: border-box;
                                cursor: pointer;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }
                        }
                    }

                    .select-box {
                        margin: 0 auto;
                        width: 260px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        > div:nth-of-type(2) {
                            display: flex;

                            > div {
                                margin-left: 10px;
                                width: 88px;
                                height: 32px;
                                border: 1px solid rgba(242, 242, 242, 1);
                                opacity: 1;
                                border-radius: 16px;
                                text-align: center;
                                line-height: 32px;
                                cursor: pointer;
                            }

                            .select {
                                background: #EEEEEE;
                            }
                        }

                    }
                }

                .nav-list {
                    box-sizing: border-box;
                    height: calc(100% - 95px);
                    overflow: auto;
                    /*修改滚动条样式*/

                    .nav-title {
                        font-size: 16px;
                        font-weight: bold;
                        width: 260px;
                        margin: 0 auto;
                    }

                    .school-box {
                        .school-item {
                            width: 260px;
                            margin: 10px auto;
                            display: flex;
                            justify-content: space-between;
                            background: #FFF;
                            border: 1px solid rgba(0, 0, 0, 0.05);
                            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                            border-radius: 6px;
                            font-size: 14px;
                            line-height: 20px;
                            padding: 12px 16px;
                            cursor: pointer;
                            user-select: none;
                            color: rgba(51, 51, 51, 1);
                            font-weight: 600;
                            box-sizing: border-box;

                            &:hover {
                                background: #ffe800;
                                box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
                                border: 1px solid #00809D;
                                color: #00809D;
                            }

                            > span {
                                color: #999999;
                            }
                        }

                        .school-item-focus {
                            background: #ffe800;
                            box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
                            border: 1px solid #00809D;
                            color: #00809D;
                        }
                    }
                }
            }

            .map-content {
                /*width: calc(100% - 320px);*/
                flex: 1;
                height: 100%;
                position: relative;

                .map-select {
                    background: rgba(247, 247, 247, 0.8);
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 57px;
                    z-index: 300;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    border-bottom: 1px solid #ddd;
                    padding: 0 24px;

                    > div:nth-of-type(2) {
                        display: flex;
                        color: #333333;
                        font-weight: bold;

                        > div {
                            padding: 0 10px;
                            height: 58px;
                            line-height: 58px;
                            cursor: pointer;
                            border-bottom: 2px solid transparent;
                            box-sizing: border-box;
                        }

                        .select-focus {
                            border-bottom: 2px solid rgb(1, 128, 157, 1);
                            transition: all .5s;
                        }
                    }
                }

                #map {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    top: 0;
                    left: 0;
                }

                .info {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    top: 0;
                    left: 0;
                    background: white;
                    box-sizing: border-box;
                    padding-top: 100px;
                    overflow: scroll;

                    .info-title {
                        font-weight: bold;
                        font-size: 16px;
                        margin-bottom: 12px;
                    }

                    .info-box {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;

                        .info-item {
                            width: 12.5%;
                            min-width: 220px;
                            height: 200px;
                            display: flex;
                            justify-content: center;
                            margin-bottom: 20px;

                            .info-item-content {
                                width: 200px;
                                height: 100%;
                                border: 1px solid rgba(0, 0, 0, 0.05);
                                box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                                box-sizing: border-box;
                                cursor: pointer;

                                > div:nth-of-type(1) {
                                    width: 100%;
                                    height: 90px;

                                    > img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }

                                > div:nth-of-type(2) {
                                    margin: 5px auto 10px;
                                    font-size: 13px;
                                    width: 85%;
                                    height: 53px;
                                    line-height: 18px;
                                }

                                > div:nth-of-type(3) {
                                    margin: 0 auto;
                                    font-size: 13px;
                                    width: 85%;
                                    line-height: 18px;
                                    color: rgba(118, 118, 118, 1);
                                }
                            }
                        }
                    }
                }

                .school-info {
                    position: absolute;
                    background: white;
                    width: auto;
                    /*height: calc(90% - 30px);*/
                    left: 10px;
                    top: 10px;
                    /*transform: translateY(-50%);*/
                    overflow: auto;
                    padding-top: 30px;

                    > h2 {
                        width: 85%;
                        margin: 10px auto;
                        color: #333333;
                    }

                    .info-banner {
                        width: 85%;
                        margin: 10px auto;

                        > img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .info-introduce {
                        width: 85%;
                        margin: 10px auto 20px;
                    }

                    #fractional-line {
                        width: 270px;
                        height: 160px;
                        margin: 10px auto;
                    }

                    .school-info-box {
                        width: 85%;
                        margin: 10px auto;

                        > div:nth-of-type(1) {
                            margin-top: 20px;
                            width: 100%;
                        }

                        .img-box {
                            width: 100%;

                            > img {
                                width: 100%;
                            }
                        }
                    }

                    .code {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 96px;
                            height: 96px;
                            margin-right: 10px;
                        }

                        > div {
                            width: 125px;
                            height: 35px;
                            line-height: 17px;
                            color: rgba(51, 51, 51, 1);
                        }
                    }
                }
            }
        }

        /**
        导航栏资讯列表样式
         */

        .list-item {
            margin: 10px auto;
            width: 250px;

            .item-top {
                width: 100%;
                display: flex;
                padding: 10px;
                border: 1px solid rgba(0, 0, 0, 0.05);
                box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                border-radius: 6px;
                box-sizing: border-box;
                cursor: pointer;

                .banner-box {
                    width: 78px;
                    height: 76px;
                    overflow: hidden;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .item-content {
                    height: 76px;
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    > div:nth-of-type(1) {
                        width: 149px;
                        height: 58px;
                        font-size: 13px;
                        color: rgba(51, 51, 51, 1);
                    }

                    > div:nth-of-type(2) {
                        /*width: 65px;*/
                        height: 16px;
                        font-size: 12px;
                        color: rgba(118, 118, 118, 1);
                    }
                }
            }

            .item-bottom {
                margin-top: 10px;
                width: 100%;
                display: flex;
                flex-direction: column;
                padding: 10px;
                border: 1px solid rgba(0, 0, 0, 0.05);
                box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                border-radius: 6px;
                box-sizing: border-box;
                cursor: pointer;

                > div:nth-of-type(1) {
                    /*width: 244px;*/
                    height: 58px;
                    font-size: 13px;
                }

                > div:nth-of-type(2) {
                    height: 16px;
                    font-size: 12px;
                }
            }
        }

        /**
        资讯更多按钮
         */

        .more-btn {
            width: 170px;
            height: 40px;
            margin: 20px auto;
            text-align: center;
            line-height: 40px;
            color: rgba(118, 118, 118, 1);
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
            border-radius: 20px;
            cursor: pointer;
        }

        .pagination-box {
            margin: 20px auto;
            display: flex;
            justify-content: center;
        }

        .details {
            margin: 0 auto;
            width: 80%;
            height: 60vh;

            > h1 {
                font-size: 22px;
                color: black;
                height: 60px;
                line-height: 30px;
            }

            > div:nth-of-type(1) {
                margin: 15px auto;
            }

            /*min-width: 1000px;*/
            /*min-height: 600px;*/
        }
    }

    .swiper-img {
        width: 100%;
    }
</style>
